import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileCTA from "./components/MobileCTA";
import ScrollToTop from "./components/ScrollToTop";
import Seo from "./components/Seo";
import useReveal from "./hooks/useReveal";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Premium from "./pages/Premium";
import Contact from "./pages/Contact";
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import SafetyCompliance from "./pages/SafetyCompliance";
import Areas from "./pages/Areas";
import Area from "./pages/Area";
import "./styles/ProClimb.css";

const RevealManager = () => {
  useReveal();
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <a href="#main" className="skip-link">Skip to content</a>
        <Seo />
        <ScrollToTop />
        <RevealManager />
        <Header />
        <main id="main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceId" element={<Services />} />
            <Route path="/areas" element={<Areas />} />
            <Route path="/areas/:areaSlug" element={<Area />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/safety-compliance" element={<SafetyCompliance />} />
          </Routes>
        </main>
        <Footer />
        <MobileCTA />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
